webpackJsonp([17],{

/***/ 1118:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoicesList_vue__ = __webpack_require__(1271);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_570f1345_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoicesList_vue__ = __webpack_require__(1426);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoicesList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_570f1345_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoicesList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http__ = __webpack_require__(26);

/* harmony default export */ __webpack_exports__["a"] = ({
  getInvoices: function getInvoices(params) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get('/v2/nomination-invoices', {
      params: params
    });
  },
  getPdf: function getPdf(invoiceId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].get("/v2/nomination-invoices/".concat(invoiceId, "/pdf"), {
      silent: true
    });
  },
  getStripeSecret: function getStripeSecret(invoiceId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/nomination-invoices/".concat(invoiceId, "/stripe-client-secret"), {});
  },
  confirmPayment: function confirmPayment(invoiceId, data) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/nomination-invoices/".concat(invoiceId, "/confirm-payment"), data, {
      silent: true
    });
  },
  resend: function resend(draftId, userId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/drafts/".concat(draftId, "/nomination-invoices/users/").concat(userId, "/resend"), {}, {
      silent: true,
      localSuccess: true
    });
  },
  remind: function remind(draftId) {
    return __WEBPACK_IMPORTED_MODULE_0__http__["a" /* default */].post("/v2/drafts/".concat(draftId, "/nomination-invoices/remind"), {}, {
      silent: true,
      localSuccess: true
    });
  }
});

/***/ }),

/***/ 1271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Pagination__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Invoices_InvoiceRow__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Invoices_InvoiceStripeForm__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__composables_invoices_useInvoicesList__ = __webpack_require__(1425);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'InvoicesList',
  components: {
    TabLayout: __WEBPACK_IMPORTED_MODULE_1__components_TabLayout__["a" /* default */],
    PageHeading: __WEBPACK_IMPORTED_MODULE_2__components_PageHeading__["a" /* default */],
    Pagination: __WEBPACK_IMPORTED_MODULE_3__components_Pagination__["a" /* default */],
    InvoiceRow: __WEBPACK_IMPORTED_MODULE_4__components_Invoices_InvoiceRow__["a" /* default */],
    InvoiceStripeForm: __WEBPACK_IMPORTED_MODULE_5__components_Invoices_InvoiceStripeForm__["a" /* default */]
  },
  setup: function setup() {
    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var _useInvoicesList = Object(__WEBPACK_IMPORTED_MODULE_6__composables_invoices_useInvoicesList__["a" /* default */])(),
        invoices = _useInvoicesList.invoices,
        page = _useInvoicesList.page,
        totalPages = _useInvoicesList.totalPages,
        loading = _useInvoicesList.loading,
        selectedInvoice = _useInvoicesList.selectedInvoice,
        fetchInvoices = _useInvoicesList.fetchInvoices,
        openStripeForm = _useInvoicesList.openStripeForm,
        closeStripeForm = _useInvoicesList.closeStripeForm,
        generatePdf = _useInvoicesList.generatePdf,
        generatingPdfIds = _useInvoicesList.generatingPdfIds;

    var initialPage = parseInt(proxy.$route.query.page, 10) || 1;
    fetchInvoices(initialPage);

    function onPageChange(p) {
      if (proxy.$route.query.page !== String(p)) {
        proxy.$router.replace({
          query: _objectSpread({}, proxy.$route.query, {
            page: String(p)
          })
        });
      }

      fetchInvoices(p);
    }

    function onPay(invoice) {
      openStripeForm(invoice);
      Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["f" /* nextTick */])(function () {
        if (proxy.$refs.stripeForm != null) {
          proxy.$refs.stripeForm.$el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    }

    function onPaid() {
      closeStripeForm();
      fetchInvoices(page.value);
    }

    return {
      invoices: invoices,
      page: page,
      totalPages: totalPages,
      loading: loading,
      selectedInvoice: selectedInvoice,
      openStripeForm: openStripeForm,
      closeStripeForm: closeStripeForm,
      generatePdf: generatePdf,
      generatingPdfIds: generatingPdfIds,
      onPageChange: onPageChange,
      onPay: onPay,
      onPaid: onPaid
    };
  }
}));

/***/ }),

/***/ 1272:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'InvoiceRow',
  props: {
    invoice: {
      type: Object,
      required: true
    },
    generating: {
      type: Boolean,
      default: false
    }
  },
  emits: ['pay', 'generate-pdf']
}));

/***/ }),

/***/ 1273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stripe_stripe_js__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Modal__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_AppButton__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_api_invoices__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_EventBus__ = __webpack_require__(18);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["c" /* defineComponent */])({
  name: 'InvoiceStripeForm',
  components: {
    Modal: __WEBPACK_IMPORTED_MODULE_2__components_Modal__["a" /* default */],
    AppButton: __WEBPACK_IMPORTED_MODULE_3__components_AppButton__["a" /* default */]
  },
  props: {
    invoice: {
      type: Object,
      required: true
    }
  },
  emits: ['close', 'paid'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit;

    var _getCurrentInstance = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["d" /* getCurrentInstance */])(),
        proxy = _getCurrentInstance.proxy;

    var cardEl = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);
    var ready = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var submitting = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
    var errorMessage = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])('');
    var stripe = null;
    var card = null;
    var clientSecret = null;
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["i" /* onMounted */])(
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee() {
      var _ref3, _ref4, stripeInstance, secretRes, elements;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return Promise.all([Object(__WEBPACK_IMPORTED_MODULE_1__stripe_stripe_js__["a" /* loadStripe */])(proxy.$stripePk), __WEBPACK_IMPORTED_MODULE_4__services_api_invoices__["a" /* default */].getStripeSecret(props.invoice.id)]);

            case 3:
              _ref3 = _context.sent;
              _ref4 = _slicedToArray(_ref3, 2);
              stripeInstance = _ref4[0];
              secretRes = _ref4[1];
              stripe = stripeInstance;
              clientSecret = secretRes.data.data.client_secret;
              elements = stripe.elements();
              card = elements.create('card', {
                hidePostalCode: true
              });
              card.mount(cardEl.value);
              card.on('change', function (event) {
                errorMessage.value = event.error != null ? event.error.message : '';
              });
              ready.value = true;
              _context.next = 19;
              break;

            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](0);
              errorMessage.value = 'Unable to load the payment form. Please try again.';

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 16]]);
    })));
    Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["h" /* onBeforeUnmount */])(function () {
      if (card != null) card.destroy();
    });

    function submit() {
      return _submit.apply(this, arguments);
    }

    function _submit() {
      _submit = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2() {
        var _ref5, error, res, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(stripe == null || card == null || clientSecret == null || submitting.value)) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return");

              case 2:
                submitting.value = true;
                errorMessage.value = '';
                _context2.prev = 4;
                _context2.next = 7;
                return stripe.confirmCardPayment(clientSecret, {
                  payment_method: {
                    card: card
                  }
                });

              case 7:
                _ref5 = _context2.sent;
                error = _ref5.error;

                if (!(error != null)) {
                  _context2.next = 12;
                  break;
                }

                errorMessage.value = error.type === 'card_error' || error.type === 'validation_error' ? error.message : 'An unexpected error occurred.';
                return _context2.abrupt("return");

              case 12:
                _context2.next = 14;
                return __WEBPACK_IMPORTED_MODULE_4__services_api_invoices__["a" /* default */].confirmPayment(props.invoice.id, {});

              case 14:
                res = _context2.sent;
                __WEBPACK_IMPORTED_MODULE_5__store_EventBus__["a" /* default */].$emit('show-success', res.data.message != null ? res.data.message : 'Payment completed successfully.');
                emit('paid');
                _context2.next = 23;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2["catch"](4);
                data = _context2.t0.response != null ? _context2.t0.response.data : null;
                errorMessage.value = data != null && data.message != null ? data.message : 'An unexpected error occurred.';

              case 23:
                _context2.prev = 23;
                submitting.value = false;
                return _context2.finish(23);

              case 26:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[4, 19, 23, 26]]);
      }));
      return _submit.apply(this, arguments);
    }

    function close(event) {
      if (event != null && typeof event.preventDefault === 'function') {
        event.preventDefault();
      }

      if (submitting.value) return;
      emit('close');
    }

    return {
      cardEl: cardEl,
      ready: ready,
      submitting: submitting,
      errorMessage: errorMessage,
      submit: submit,
      close: close
    };
  }
}));

/***/ }),

/***/ 1419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceRow_vue__ = __webpack_require__(1272);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32f4d064_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceRow_vue__ = __webpack_require__(1420);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceRow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32f4d064_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceRow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invoice_row"},[_c('span',{staticClass:"invoices_cell",attrs:{"data-label":"Date"}},[_vm._v(_vm._s(_vm.invoice.date))]),_vm._v(" "),_c('span',{staticClass:"invoices_cell invoice_draft",attrs:{"data-label":"Draft","title":_vm.invoice.draftName}},[_vm._v(_vm._s(_vm.invoice.draftName))]),_vm._v(" "),_c('span',{staticClass:"invoices_cell invoice_number",attrs:{"data-label":"Invoice #"}},[(_vm.invoice.pdfUrl)?_c('a',{staticClass:"invoice_number_value",attrs:{"href":_vm.invoice.pdfUrl,"target":"_blank","rel":"noopener","title":"Download invoice"}},[_c('span',{staticClass:"invoice_number_link"},[_vm._v(_vm._s(_vm.invoice.number))]),_vm._v(" "),_c('span',{staticClass:"download_icon invoice_pdf_inline"})]):_c('span',{staticClass:"invoice_number_value"},[_c('span',{staticClass:"invoice_number_link"},[_vm._v(_vm._s(_vm.invoice.number))]),_vm._v(" "),(_vm.generating)?_c('span',{staticClass:"download_icon download_icon--spinner invoice_pdf_inline"}):(_vm.invoice.canGeneratePdf)?_c('button',{staticClass:"download_icon download_icon--generate invoice_pdf_inline",attrs:{"title":"Generate invoice PDF"},on:{"click":function($event){return _vm.$emit('generate-pdf')}}}):_vm._e()])]),_vm._v(" "),_c('span',{staticClass:"invoices_cell",attrs:{"data-label":"Invoice Type"}},[_vm._v(_vm._s(_vm.invoice.invoiceType || '-'))]),_vm._v(" "),_c('span',{staticClass:"invoices_cell invoice_payment_type",attrs:{"data-label":"Payment Type"}},[_vm._v(_vm._s(_vm.invoice.paymentType || '-'))]),_vm._v(" "),_c('span',{staticClass:"invoices_cell invoice_paid_amount",attrs:{"data-label":"Paid Amount"}},[_vm._v(_vm._s(_vm.invoice.isOutgoing ? _vm.invoice.total : (_vm.invoice.paymentType ? _vm.invoice.paidAmount : '-')))]),_vm._v(" "),_c('span',{staticClass:"invoices_cell invoice_status_cell",attrs:{"data-label":"Status"}},[_vm._v(_vm._s(_vm.invoice.paymentStatus === 'paid' ? 'Paid' : 'Unpaid'))]),_vm._v(" "),_c('span',{staticClass:"invoices_cell invoice_pay_cell"},[(_vm.invoice.needToPay)?_c('button',{staticClass:"invoice_pay_button pay-button btn btn-primary px-lg-3",on:{"click":function($event){return _vm.$emit('pay', _vm.invoice)}}},[_vm._v("\n      Pay "+_vm._s(_vm.invoice.total)+"\n    ")]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1421:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceStripeForm_vue__ = __webpack_require__(1273);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af79b6e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceStripeForm_vue__ = __webpack_require__(1424);
function injectStyle (ssrContext) {
  __webpack_require__(1422)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-af79b6e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InvoiceStripeForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af79b6e4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InvoiceStripeForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1422:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1423);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1093)("1821c308", content, true, {});

/***/ }),

/***/ 1423:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1092)(true);
// imports


// module
exports.push([module.i, ".stripe-form__element[data-v-af79b6e4]{height:auto;padding-top:12px;padding-bottom:12px}", "", {"version":3,"sources":["/opt/atlassian/pipelines/agent/build/src/components/Invoices/InvoiceStripeForm.vue"],"names":[],"mappings":"AACA,uCACE,YAAa,AACb,iBAAkB,AAClB,mBAAqB,CACtB","file":"InvoiceStripeForm.vue","sourcesContent":["\n.stripe-form__element[data-v-af79b6e4] {\n  height: auto;\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{attrs:{"size":"md","content-class":"p-sm-4"},on:{"close":_vm.close},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h5',{staticClass:"mb-0"},[_vm._v("Pay Invoice")])]},proxy:true},{key:"body",fn:function(){return [(_vm.invoice.total)?_c('p',{staticClass:"text-center mb-3"},[_vm._v("\n      Amount to pay: "),_c('strong',[_vm._v("$"+_vm._s(_vm.invoice.total))])]):_vm._e(),_vm._v(" "),_c('label',{staticClass:"d-block mb-1 small text-muted"},[_vm._v("Card details")]),_vm._v(" "),_c('div',{ref:"cardEl",staticClass:"form-control stripe-form__element"}),_vm._v(" "),(_vm.errorMessage)?_c('div',{staticClass:"text-danger small mt-2"},[_vm._v(_vm._s(_vm.errorMessage))]):_vm._e()]},proxy:true},{key:"footer",fn:function(){return [_c('app-button',{attrs:{"variant":"outline-primary","disabled":_vm.submitting},on:{"click":_vm.close}},[_vm._v("Cancel")]),_vm._v(" "),_c('app-button',{attrs:{"loading":_vm.submitting,"disabled":!_vm.ready},on:{"click":_vm.submit}},[_vm._v("Pay Now")])]},proxy:true}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useInvoicesList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__vue_composition_api__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_api_invoices__ = __webpack_require__(1158);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }




function mapInvoice(inv) {
  return {
    id: inv.id,
    date: inv.date != null ? inv.date : '',
    draftName: inv.draft != null ? inv.draft.name : '',
    number: inv.invoice_number,
    total: inv.total_cost != null ? inv.total_cost.toFixed(2) : '0.00',
    needToPay: inv.need_to_pay,
    pdfUrl: inv.pdf_url,
    canGeneratePdf: inv.can_generate_pdf,
    isOutgoing: inv.is_outgoing,
    committee: inv.committee,
    invoiceType: inv.invoice_type,
    paymentType: inv.payment_type,
    paidAmount: inv.paid_amount != null ? inv.paid_amount.toFixed(2) : '0.00',
    paymentStatus: inv.payment_status
  };
}

function useInvoicesList() {
  var invoices = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])([]);
  var page = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(1);
  var totalPages = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(1);
  var loading = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(false);
  var selectedInvoice = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(null);

  function fetchInvoices(_x) {
    return _fetchInvoices.apply(this, arguments);
  }

  function _fetchInvoices() {
    _fetchInvoices = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(p) {
      var res, d, meta;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (p != null) page.value = p;
              loading.value = true;
              _context.prev = 2;
              _context.next = 5;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_invoices__["a" /* default */].getInvoices({
                page: page.value
              });

            case 5:
              res = _context.sent;
              d = res.data;
              invoices.value = (d.data != null ? d.data : []).map(mapInvoice);
              meta = d.meta != null ? d.meta : {};
              page.value = meta.current_page != null ? meta.current_page : 1;
              totalPages.value = meta.last_page != null ? meta.last_page : 1;
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](2);
              invoices.value = [];

            case 16:
              _context.prev = 16;
              loading.value = false;
              return _context.finish(16);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 13, 16, 19]]);
    }));
    return _fetchInvoices.apply(this, arguments);
  }

  function openStripeForm(invoice) {
    selectedInvoice.value = invoice;
  }

  function closeStripeForm() {
    selectedInvoice.value = null;
  }

  var generatingPdfIds = Object(__WEBPACK_IMPORTED_MODULE_0__vue_composition_api__["l" /* ref */])(new Set());

  function generatePdf(_x2) {
    return _generatePdf.apply(this, arguments);
  }

  function _generatePdf() {
    _generatePdf = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(invoiceId) {
      var res, url, item, next;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!generatingPdfIds.value.has(invoiceId)) {
                _context2.next = 2;
                break;
              }

              return _context2.abrupt("return");

            case 2:
              generatingPdfIds.value = new Set([].concat(_toConsumableArray(generatingPdfIds.value), [invoiceId]));
              _context2.prev = 3;
              _context2.next = 6;
              return __WEBPACK_IMPORTED_MODULE_1__services_api_invoices__["a" /* default */].getPdf(invoiceId);

            case 6:
              res = _context2.sent;
              url = res.data.data.url;

              if (url) {
                _context2.next = 10;
                break;
              }

              return _context2.abrupt("return");

            case 10:
              window.open(url, '_blank');
              item = invoices.value.find(function (i) {
                return i.id === invoiceId;
              });
              if (item) item.pdfUrl = url;
              _context2.next = 17;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](3);

            case 17:
              _context2.prev = 17;
              next = new Set(generatingPdfIds.value);
              next.delete(invoiceId);
              generatingPdfIds.value = next;
              return _context2.finish(17);

            case 22:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[3, 15, 17, 22]]);
    }));
    return _generatePdf.apply(this, arguments);
  }

  return {
    invoices: invoices,
    page: page,
    totalPages: totalPages,
    loading: loading,
    selectedInvoice: selectedInvoice,
    fetchInvoices: fetchInvoices,
    openStripeForm: openStripeForm,
    closeStripeForm: closeStripeForm,
    generatePdf: generatePdf,
    generatingPdfIds: generatingPdfIds
  };
}

/***/ }),

/***/ 1426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-layout',{attrs:{"full-width":true}},[_c('div',{staticClass:"bg-white rounded mb-4 p-3",attrs:{"slot":"tabContent"},slot:"tabContent"},[_c('page-heading',[_vm._v("Invoices")]),_vm._v(" "),(!_vm.loading && !_vm.invoices.length)?[_vm._v("No invoice found.")]:_c('div',{staticClass:"invoices_container_main"},[(_vm.loading)?_c('div',{staticClass:"table-overlay"},[_c('div',{staticClass:"table-spinner"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"invoices_table"},[_c('div',{staticClass:"invoices_table_header"},[_c('span',[_vm._v("Date")]),_vm._v(" "),_c('span',{staticClass:"invoice_draft"},[_vm._v("Draft")]),_vm._v(" "),_c('span',{staticClass:"invoice_number"},[_vm._v("Invoice #")]),_vm._v(" "),_c('span',[_vm._v("Invoice Type")]),_vm._v(" "),_c('span',{staticClass:"invoice_payment_type"},[_vm._v("Payment Type")]),_vm._v(" "),_c('span',{staticClass:"invoice_paid_amount"},[_vm._v("Paid Amount")]),_vm._v(" "),_c('span',{staticClass:"invoice_status_cell"},[_vm._v("Status")]),_vm._v(" "),_c('span',{staticClass:"invoice_pay_cell"})]),_vm._v(" "),_vm._l((_vm.invoices),function(invoice){return _c('invoice-row',{key:invoice.id,attrs:{"invoice":invoice,"generating":_vm.generatingPdfIds.has(invoice.id)},on:{"pay":function($event){return _vm.onPay(invoice)},"generate-pdf":function($event){return _vm.generatePdf(invoice.id)}}})})],2),_vm._v(" "),(_vm.selectedInvoice != null)?_c('invoice-stripe-form',{ref:"stripeForm",attrs:{"invoice":_vm.selectedInvoice},on:{"close":_vm.closeStripeForm,"paid":_vm.onPaid}}):_vm._e()],1),_vm._v(" "),(_vm.invoices.length)?_c('pagination',{staticClass:"mt-3",attrs:{"total-pages":_vm.totalPages,"page":_vm.page,"on-change":_vm.onPageChange,"disabled":_vm.loading}}):_vm._e()],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/17.b572f5a56537ba99ebfa.js